import { useState } from "react";
import PageHeader from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { Map, ExternalLink, RefreshCw } from "lucide-react";

const MAP_URL = "https://mdt.sbi-unity.com/public-map";

export default function LiveKarte() {
  const [reloadKey, setReloadKey] = useState(0);

  return (
    <div className="flex flex-col h-screen">
      <PageHeader
        eyebrow="SADCR · Karte"
        title="Gang-Karte"
        description="Lagekarte der Gangs - bereitgestellt durch das SBI"
        icon={Map}
      />
      <div className="px-8 pt-4 flex items-center gap-2">
        <Button
          data-testid="karte-reload"
          onClick={() => setReloadKey((k) => k + 1)}
          variant="outline"
          className="rounded-sm border-zinc-700 gap-2"
        >
          <RefreshCw className="h-4 w-4" /> Karte neu laden
        </Button>
        <a href={MAP_URL} target="_blank" rel="noopener noreferrer">
          <Button data-testid="karte-open-extern" variant="outline" className="rounded-sm border-zinc-700 gap-2">
            <ExternalLink className="h-4 w-4" /> In neuem Tab öffnen
          </Button>
        </a>
      </div>
      <div className="flex-1 p-8 pt-4 min-h-0">
        <div className="h-full w-full border border-zinc-800 rounded-sm overflow-hidden bg-[#0C0E12]">
          <iframe
            key={reloadKey}
            data-testid="karte-iframe"
            src={MAP_URL}
            title="Gang-Karte"
            className="w-full h-full"
            style={{ border: 0 }}
            allow="geolocation; fullscreen"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </div>
  );
}
